import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = ({ onAccept, onDecline }) => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <div className="terms-header">
          <h2>Nutzungsbedingungen &amp; AGB</h2>
          <p className="terms-subtitle">HiFi Community Gebrauchtmarkt</p>
        </div>
        
        <div className="terms-scroll-area">
          <div className="terms-section">
            <h3>§1 Allgemeines</h3>
            <p>
              Der „HiFi Community Gebrauchtmarkt" ist eine Plattform, die ausschließlich für private Verkäufe von Audio-Equipment 
              bestimmt ist. Die Nutzung der Plattform für gewerbliche Zwecke ist untersagt. Der Betreiber der Website 
              übernimmt keine Gewährleistung oder Garantie für die angebotenen Artikel und tritt nicht als Vermittler oder 
              Partei bei Transaktionen auf.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>§2 Registrierung und Nutzerkonto</h3>
            <p>
              Die Registrierung auf der Plattform ist nur für Personen über 18 Jahren mit Wohnsitz in Europa gestattet. 
              Bei der Registrierung müssen wahrheitsgemäße und vollständige Angaben gemacht werden. 
              Das Nutzerkonto ist persönlich und darf nicht an Dritte weitergegeben werden.
            </p>
            <p>
              Es ist nicht gestattet, mehrere Benutzerkonten zu erstellen oder ein Konto nach einer Sperrung neu anzulegen.
              Der Betreiber behält sich das Recht vor, Konten zu deaktivieren, wenn 90 Tage lang keine Anmeldung erfolgt.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>§3 Angebote und Verkauf</h3>
            <p>
              <strong>Wichtig: Es dürfen ausschließlich Artikel aus dem Bereich Audiogeräte und Audio-Zubehör zum Verkauf angeboten werden.</strong>
            </p>
            <p>
              Angebote müssen wahrheitsgetreu und ausführlich beschrieben werden. Alle Mängel müssen angegeben werden.
              Jede Anzeige muss mindestens ein Foto des tatsächlichen Artikels enthalten. Angebote, die diese Anforderungen 
              nicht erfüllen, können gelöscht werden.
            </p>
            <p>
              Alle Verkäufe sind Privatverkäufe. Es wird ausdrücklich keine Gewährleistung oder Garantie übernommen. 
              Es wird empfohlen, den bereitgestellten Privatverkaufsvordruck zu verwenden und von beiden Parteien unterzeichnen zu lassen.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>§4 Sicherheit beim Kauf und Verkauf</h3>
            <p>
              <strong>Zu Ihrer eigenen Sicherheit:</strong>
            </p>
            <ul>
              <li>Nehmen Sie immer zuerst telefonischen Kontakt mit dem Verkäufer auf</li>
              <li>Prüfen Sie die Ware vor Ort und beim Verkäufer, bevor Sie bezahlen</li>
              <li>Seien Sie vorsichtig bei ungewöhnlich günstigen Angeboten</li>
              <li>Verwenden Sie bei persönlichen Übergaben den Privatverkaufsvordruck</li>
              <li>Bei Versand: Nutzen Sie sichere Zahlungsmethoden und lassen Sie sich den Versand bestätigen</li>
            </ul>
          </div>
          
          <div className="terms-section">
            <h3>§5 Verbotene Inhalte</h3>
            <p>
              Es ist verboten, Angebote einzustellen, die:
            </p>
            <ul>
              <li>Keine Audiogeräte oder Audio-Zubehör sind</li>
              <li>Gegen geltendes Recht verstoßen</li>
              <li>Gefälschte oder illegal kopierte Waren sind</li>
              <li>Rechte Dritter verletzen (inkl. geistiges Eigentum)</li>
            </ul>
            <p>
              Der Betreiber behält sich vor, solche Angebote ohne Vorankündigung zu löschen und bei 
              schwerwiegenden Verstößen das betreffende Nutzerkonto zu sperren.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>§6 Haftungsausschluss</h3>
            <p>
              Der Betreiber haftet nicht für Schäden, die aus der Nutzung der Plattform entstehen. 
              Insbesondere übernimmt der Betreiber keine Haftung für:
            </p>
            <ul>
              <li>Die Richtigkeit der Angebote</li>
              <li>Die Qualität der angebotenen Waren</li>
              <li>Die Abwicklung der Transaktionen</li>
              <li>Finanzielle oder andere Verluste, die aus der Nutzung der Plattform entstehen</li>
            </ul>
          </div>
          
          <div className="terms-section">
            <h3>§7 Datenschutz</h3>
            <p>
              Alle im Rahmen der Registrierung und Nutzung erhobenen personenbezogenen Daten werden vertraulich behandelt 
              und nicht an Dritte weitergegeben. Details sind in der Datenschutzerklärung aufgeführt.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>§8 Schlussbestimmungen</h3>
            <p>
              Der Betreiber behält sich das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. 
              Bei Änderungen werden die Nutzer informiert und müssen die neuen Bedingungen akzeptieren, 
              um die Plattform weiterhin nutzen zu können.
            </p>
            <p>
              Es gilt deutsches Recht. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt der restliche Vertrag davon unberührt.
            </p>
          </div>
        </div>
        
        <div className="terms-actions">
          <div className="private-use-notice">
            <span className="material-symbols-outlined">info</span>
            <p>Diese Plattform darf <strong>ausschließlich für private Zwecke</strong> genutzt werden. Gewerbliche Nutzung ist verboten.</p>
          </div>
          
          <div className="terms-buttons">
            <button onClick={onDecline} className="decline-button">
              <span className="material-symbols-outlined">close</span>
              Ablehnen
            </button>
            <button onClick={onAccept} className="accept-button">
              <span className="material-symbols-outlined">check</span>
              Ich akzeptiere die Nutzungsbedingungen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;